export enum CookiesKey {
  Lang = 'Lang',
  ClientRouter = 'clientRouter',
  Token = 'token',
  RefreshToken = 'refresh-token',
  TokenAdmin = 'token',
  RefreshTokenAdmin = 'refresh-token',
  // TokenAdmin = 'token-admin',
  // RefreshTokenAdmin = 'refresh-token-admin',
  TokenPartner = 'token-partner',
  RefreshTokenPartner = 'refresh-token-partner',
  Voucher = 'voucher',
  BetbyToken = 'operatorToken',
  Register = 'register',
  CasinoLang = 'casino-lang',
  ByPass = 'bypass',
  HideBonusCardMobile = 'hide-bonus-card-mobile',
  LastUserBonusId = 'last-user-bonus-id',
  UserEmail = '_usermail',
  DailyUserAccess = 'daily-user-access',
  HasKyc = 'has-kyc',
  OriginId = 'origin-id',
  IsAdminView = 'is-admin-view',
  UserUUID = 'user-uuid',
  TempToken = 'temp-token',
  TempRefreshToken = 'temp-refresh-token',
  UserIp = 'user-ip',
  FirstLoginBonusModal = 'first-login-bonus-modal',
  GeoLocation = 'geo-location',
  Device = 'device',
  XBrowser = 'x-browser',
  AgeCheck = 'age-check',
}
